import { Typography } from "@mui/material";

const StepsHeading = ( { title } ) => {
  return (
      <Typography align="center" sx={ {
        fontSize: { xs: '20px', sm: '22px', md: '24px' },
        fontWeight: "700",
        lineHeight: { xs: '24px', sm: '27px', md: '32px' },
        textAlign: "center",
        px: { xs: 1, sm: 4 },
        width: '100%',
        paddingTop: {
          xs: "10px", sm: 1,
        }
      } }
      >
        { title }
      </Typography>
  )

}

export default StepsHeading;